import { render, staticRenderFns } from "./v-sidebar.vue?vue&type=template&id=b542f816&scoped=true&"
import script from "./v-sidebar.vue?vue&type=script&lang=js&"
export * from "./v-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./v-sidebar.vue?vue&type=style&index=0&id=b542f816&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b542f816",
  null
  
)

export default component.exports